import React from "react";
import { render } from "react-dom";
import CookiePlaceholder from "../embed/CookiePlaceholder";
import Clevercast from "./Clevercast";

const renderPlaceholder = (container) => {
  container.innerHTML = "";

  const placeholder = document.createElement("div");
  placeholder.setAttribute("data-cookiebot-marketing-placeholder", "");
  container.appendChild(placeholder);
  render(<CookiePlaceholder />, placeholder);
};

const initClevercastPlayer = (container) => {
  if (!container.dataset?.clevercastLoaded) {
    container.innerHTML = "";
    new Clevercast(container);
  }
};

const handleClevercastContainerConsent = (container) => {
  if (!window.Cookiebot) {
    return;
  }

  if (window.Cookiebot.consent.marketing) {
    initClevercastPlayer(container);
  } else {
    delete container.dataset.clevercastLoaded;
    renderPlaceholder(container);
  }
};

const handleClevercastEmbedConsent = (container) => {
  if (!window.Cookiebot) {
    return;
  }

  if (window.Cookiebot.consent.marketing) {
    const htmlContent = container.getAttribute("data-html-content");

    if (container.dataset.clevercastHtmlContent !== htmlContent) {
      container.innerHTML = htmlContent;
      container.dataset.clevercastHtmlContent = htmlContent;
    }

    [
      ...(container.matches?.("[data-clevercast-video]") ? [container] : []),
      ...container.querySelectorAll("[data-clevercast-video]"),
    ].forEach(initClevercastPlayer);
  } else {
    delete container.dataset.clevercastHtmlContent;
    renderPlaceholder(container);
  }
};

const getElements = (root, selector) => {
  if (!root) {
    return [];
  }

  return [
    ...(root.matches?.(selector) ? [root] : []),
    ...root.querySelectorAll(selector),
  ];
};

const fillInClevercastContainers = (root = document) => {
  const clevercastEmbedContainers = getElements(
    root,
    ".embed-container--clevercast[data-embed-container]"
  );
  [...clevercastEmbedContainers].forEach(handleClevercastEmbedConsent);

  const clevercastContainers = getElements(root, "[data-clevercast-video]");
  [...clevercastContainers]
    .filter(
      (container) =>
        !container.closest(".embed-container--clevercast[data-embed-container]")
    )
    .forEach(handleClevercastContainerConsent);
};

const initClevercastContainers = (root = document) => {
  fillInClevercastContainers(root);
};

(() => {
  const video = document.querySelector(".video");

  if (video) {
    initClevercastContainers();
  }

  window.addEventListener("CookiebotOnAccept", () => {
    initClevercastContainers();
  });

  window.addEventListener("CookiebotOnDecline", () => {
    initClevercastContainers();
  });
})();

export { initClevercastContainers };
